module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/3-9407f17a6d708033319b8f760ea347c9.jpg";